export class NumberHelper {
  public static int32MaxValue = 2147483647;
  public static int32MinValue = -2147483647;

  public static calcHumanReadableFileSize(bytes: number | null | undefined): string {
    if (!bytes && bytes !== 0) {
      return '';
    }

    // bytes
    if (bytes < 1024) {
      return `${NumberHelper.round(bytes)} octets`;
    }

    // kilobytes
    const kbytes = bytes / 1024;
    if (NumberHelper.round(kbytes) < 1024) {
      return `${NumberHelper.round(kbytes)} Ko`;
    }

    // megabytes
    const mbytes = kbytes / 1024;
    if (NumberHelper.round(mbytes) < 1024) {
      return `${NumberHelper.round(mbytes)} Mo`;
    }

    // gigabytes
    const gbytes = mbytes / 1024;
    if (NumberHelper.round(gbytes) < 1024) {
      return `${NumberHelper.round(gbytes)} Go`;
    }

    // terabytes
    const tbytes = gbytes / 1024;
    return `${NumberHelper.round(tbytes)} To`;
  }

  public static calcPercentage(x: number | null | undefined, total: number | null | undefined): number {
    if (total === 0) {
      return 0;
    } else {
      return (x! / total!) * 100;
    }
  }

  public static round(x: number | null | undefined): number {
    return Math.round((x! + Number.EPSILON) * 100) / 100;
  }
}
